export class Smtp {
  id?:number;
  host?:string;
  user?:string;
  password?:string;
  port?: number;
  ssl?:string;
  protocol?:string;
  enabled?:boolean;
  tipo?: string;
}
